/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Authorization Service
 * API by Compax
 * OpenAPI spec version: 152.0.0-SNAPSHOT
 */

export type ChangeTwoFactorAuthenticationMethod =
  (typeof ChangeTwoFactorAuthenticationMethod)[keyof typeof ChangeTwoFactorAuthenticationMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeTwoFactorAuthenticationMethod = {
  SMS: "SMS",
  APP: "APP",
  STANDARD: "STANDARD",
} as const;
